var _defs, _g, _g2, _g3, _g4, _g5, _g6, _path, _g7, _g8, _g9, _g10, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataWarehouseDataLakeDataengineering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 677.93 657.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-12 {\n        fill: #002c5f;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 327.85,
    y: 559.84,
    width: 20.19,
    height: 77.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 366.11,
    y: 588.54,
    width: 20.19,
    height: 48.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 289.58,
    y: 588.54,
    width: 20.19,
    height: 48.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 327.85,
    y: 21.94,
    width: 20.19,
    height: 77.67
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 289.58,
    y: 21.94,
    width: 20.19,
    height: 48.98
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 366.11,
    y: 21.94,
    width: 20.19,
    height: 48.98
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.16,
    y: 21.94,
    width: 144.63,
    height: 135.07
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 501.1,
    y: 21.94,
    width: 144.47,
    height: 135.07
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.16,
    y: 502.45,
    width: 144.63,
    height: 134.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 501.1,
    y: 502.45,
    width: 144.47,
    height: 134.9
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m337.74,560.2c-5.29,0-9.61,4.33-9.61,9.61v57.67c0,5.29,4.33,9.61,9.61,9.61s9.61-4.33,9.61-9.61v-57.67c0-5.29-4.33-9.61-9.61-9.61Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m376.18,589.04c-5.29,0-9.61,4.32-9.61,9.61v28.83c0,5.29,4.33,9.61,9.61,9.61s9.61-4.33,9.61-9.61v-28.83c0-5.29-4.33-9.61-9.61-9.61Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m299.29,589.04c-5.29,0-9.61,4.32-9.61,9.61v28.83c0,5.29,4.32,9.61,9.61,9.61s9.61-4.33,9.61-9.61v-28.83c0-5.29-4.33-9.61-9.61-9.61Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m337.74,98.84c5.29,0,9.61-4.32,9.61-9.61V31.56c0-5.29-4.33-9.61-9.61-9.61s-9.61,4.33-9.61,9.61v57.67c0,5.29,4.33,9.61,9.61,9.61Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m299.29,70c5.29,0,9.61-4.33,9.61-9.61v-28.83c0-5.29-4.33-9.61-9.61-9.61s-9.61,4.33-9.61,9.61v28.83c0,5.29,4.32,9.61,9.61,9.61Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m376.18,70c5.29,0,9.61-4.33,9.61-9.61v-28.83c0-5.29-4.33-9.61-9.61-9.61s-9.61,4.33-9.61,9.61v28.83c0,5.29,4.33,9.61,9.61,9.61Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m337.74,166.12c-46.62,0-124.95,3.84-124.95,28.83v269.13c0,24.99,78.34,28.83,124.95,28.83h11.05c51.9-.96,113.9-6.73,113.9-28.83V194.96c0-24.99-78.34-28.83-124.95-28.83Zm105.73,93.23c-8.17,4.8-44.22,12.49-105.73,12.49s-97.56-7.69-105.73-12.49v-47.1c25.95,9.61,73.53,11.05,105.73,11.05s79.78-1.92,105.73-11.05v47.1Zm0,67.28c-8.17,4.81-44.22,12.5-105.73,12.5s-97.56-7.69-105.73-12.5v-47.09c25.95,9.61,73.53,11.05,105.73,11.05s79.78-1.92,105.73-11.05v47.09Zm0,67.29c-8.17,4.8-44.22,12.49-105.73,12.49s-97.56-7.69-105.73-12.49v-47.1c25.95,9.61,73.53,11.05,105.73,11.05s79.78-1.92,105.73-11.05v47.1Zm-105.73-208.58c50.46,0,84.1,5.29,98.52,9.61-14.9,4.33-48.06,9.61-98.52,9.61s-84.1-5.29-98.52-9.61c14.42-4.33,48.06-9.61,98.52-9.61Zm10.57,288.36h-10.57c-61.52,0-97.56-7.69-105.73-12.5v-47.1c25.95,9.61,73.53,11.06,105.73,11.06s79.78-1.92,105.73-11.06v47.1c-8.17,4.81-41.33,11.53-95.16,12.5Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m39.77,127.68h33.64v9.61h-9.61c-5.29,0-9.62,4.32-9.62,9.61s4.33,9.61,9.62,9.61h76.89c5.29,0,9.61-4.33,9.61-9.61s-4.33-9.61-9.61-9.61h-9.61v-9.61h33.64c5.29,0,9.61-4.33,9.61-9.62V31.56c0-5.29-4.33-9.61-9.61-9.61H39.77c-5.29,0-9.61,4.33-9.61,9.61v86.5c0,5.29,4.33,9.62,9.61,9.62Zm72.09,9.61h-19.22v-9.61h19.22v9.61ZM49.38,41.17h105.73v67.28H49.38V41.17Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m635.71,21.94h-124.95c-5.29,0-9.61,4.33-9.61,9.61v86.5c0,5.29,4.33,9.62,9.61,9.62h33.64v9.61h-9.61c-5.29,0-9.61,4.32-9.61,9.61s4.32,9.61,9.61,9.61h76.89c5.29,0,9.61-4.33,9.61-9.61s-4.33-9.61-9.61-9.61h-9.61v-9.61h33.64c5.29,0,9.61-4.33,9.61-9.62V31.56c0-5.29-4.33-9.61-9.61-9.61Zm-52.87,115.34h-19.22v-9.61h19.22v9.61Zm43.25-28.84h-105.73V41.17h105.73v67.28Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m164.73,502.53H39.77c-5.29,0-9.61,4.33-9.61,9.61v86.51c0,5.29,4.33,9.61,9.61,9.61h33.64v9.61h-9.61c-5.29,0-9.62,4.32-9.62,9.61s4.33,9.61,9.62,9.61h76.89c5.29,0,9.61-4.33,9.61-9.61s-4.33-9.61-9.61-9.61h-9.61v-9.61h33.64c5.29,0,9.61-4.33,9.61-9.61v-86.51c0-5.29-4.33-9.61-9.61-9.61Zm-52.87,115.34h-19.22v-9.61h19.22v9.61Zm43.25-28.83H49.38v-67.29h105.73v67.29Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m635.71,502.53h-124.95c-5.29,0-9.61,4.33-9.61,9.61v86.51c0,5.29,4.33,9.61,9.61,9.61h33.64v9.61h-9.61c-5.29,0-9.61,4.32-9.61,9.61s4.32,9.61,9.61,9.61h76.89c5.29,0,9.61-4.33,9.61-9.61s-4.33-9.61-9.61-9.61h-9.61v-9.61h33.64c5.29,0,9.61-4.33,9.61-9.61v-86.51c0-5.29-4.33-9.61-9.61-9.61Zm-52.87,115.34h-19.22v-9.61h19.22v9.61Zm43.25-28.83h-105.73v-67.29h105.73v67.29Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m188.28,287.23l-27.39-14.42c-4.81-2.4-10.57-.48-12.98,3.84-1.44,2.88-1.44,6.73,0,9.13h-40.85v-100.44c0-5.29-4.32-9.61-9.61-9.61s-9.61,4.33-9.61,9.61v110.54c0,5.29,4.33,9.61,9.61,9.61h50.94c-1.44,2.89-1.92,6.25,0,9.13,1.92,3.37,5.29,5.29,8.65,5.29,1.44,0,2.88-.48,4.32-.96l27.39-14.42c3.37-1.44,5.29-4.81,5.29-8.65s-2.4-6.73-5.77-8.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m487.2,304.53l27.39,14.42c1.44.96,2.88.96,4.33.96,3.36,0,6.73-1.92,8.65-5.29,1.44-2.88,1.44-6.73,0-9.13h50.46c5.29,0,9.61-4.33,9.61-9.61v-110.54c0-5.29-4.32-9.61-9.61-9.61s-9.61,4.33-9.61,9.61v100.92h-41.33c1.44-2.88,1.92-6.25,0-9.13-2.4-4.81-8.17-6.25-12.98-3.84l-27.39,14.42c-3.36,1.44-5.29,4.81-5.29,8.65s2.4,6.25,5.77,8.17Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m188.28,354.51l-27.39-14.42c-4.81-2.4-10.57-.48-12.98,3.84-1.44,2.89-1.44,6.73,0,9.13h-50.46c-5.29,0-9.61,4.33-9.61,9.61v110.54c0,5.29,4.33,9.61,9.61,9.61s9.61-4.33,9.61-9.61v-100.44h41.33c-1.44,2.88-1.92,6.24,0,9.13,1.92,3.36,5.29,5.29,8.65,5.29,1.44,0,2.88-.48,4.32-.96l27.39-14.42c3.37-1.44,5.29-4.8,5.29-8.65s-2.4-6.73-5.77-8.65Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m518.92,387.19c3.36,0,6.73-1.92,8.65-5.29,1.44-2.89,1.44-6.73,0-9.13h41.33v100.92c0,5.29,4.33,9.61,9.61,9.61s9.61-4.33,9.61-9.61v-110.54c0-5.29-4.33-9.62-9.61-9.62h-50.94c1.44-2.88,1.92-6.24,0-9.13-2.4-4.8-8.17-6.25-12.97-3.84l-27.39,14.42c-3.36,1.44-5.29,4.8-5.29,8.65s1.92,6.73,5.29,8.65l27.39,14.42c.96,0,2.4.48,4.33.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataWarehouseDataLakeDataengineering);
export default __webpack_public_path__ + "static/media/Data Warehouse & Data Lake_dataengineering.1f79e865fbfd77ce7bec2374bca60d5d.svg";
export { ForwardRef as ReactComponent };